/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash'
import { colors, createTheme as createMuiTheme, responsiveFontSizes } from '@material-ui/core'
import typography from './typography'
import { softShadows, strongShadows } from './shadows'
import { THEMES } from '../constants'

const themeSettings =
    process.env.MIX_DASHBOARD_THEME === 'haavi'
        ? {
              light: {
                  primary: '#4bafba',
                  seconary: '#5cc3ce',
                  background: '#f4f6f8',
                  contentBackground: '#fff',
                  graphColors: [
                      '#5cc3ce',
                      '#bce5e6',
                      '#d6dee1',
                      '#d7f3ff',
                      '#eb88d7',
                      '#ef85d4',
                      '#ffc9f4',
                      '#FF9655',
                      '#FFF263',
                      '#6AF9C4',
                      '#5cc3ce',
                      '#bce5e6'
                  ]
              },
              dark: {
                  primary: '#5cc3ce',
                  seconary: '#5cc3ce',
                  background: '#1c2025',
                  contentBackground: '#282C34',
                  graphColors: [
                      '#4bafba',
                      '#bce5e6',
                      '#d6dee1',
                      '#d7f3ff',
                      '#eb88d7',
                      '#ef85d4',
                      '#ffc9f4',
                      '#FF9655',
                      '#FFF263',
                      '#6AF9C4',
                      '#5cc3ce',
                      '#bce5e6'
                  ]
              },
              logo: {
                  light: '/static/logo-haavi-light.png',
                  dark: '/static/logo-haavi-dark.png'
              }
          }
        : {
              light: {
                  primary: colors.indigo[600],
                  secondary: '#5850EC',
                  background: '#f4f6f8',
                  contentBackground: '#fff',
                  graphColors: [
                      '#5850ec',
                      '#958fff',
                      '#c5bfff',
                      '#fbabeb',
                      '#ffc9f4',
                      '#ed80e6',
                      '#eb88d7',
                      '#ef85d4',
                      '#64E572',
                      '#FF9655',
                      '#FFF263',
                      '#6AF9C4'
                  ]
              },
              dark: {
                  primary: '#8a85ff',
                  secondary: '#8a85ff',
                  background: '#1c2025',
                  contentBackground: '#282C34',
                  graphColors: [
                      '#5850ec',
                      '#958fff',
                      '#c5bfff',
                      '#fbabeb',
                      '#ffc9f4',
                      '#ed80e6',
                      '#eb88d7',
                      '#ef85d4',
                      '#64E572',
                      '#FF9655',
                      '#FFF263',
                      '#6AF9C4'
                  ]
              },
              logo: {
                  light: '/static/logo-light.png',
                  dark: '/static/logo-dark.png'
              }
          }

const baseConfig = {
    direction: 'ltr',
    typography,
    overrides: {
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: 'hidden'
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32
            }
        },
        MuiChip: {
            root: {
                backgroundColor: 'rgba(0,0,0,0.075)'
            }
        }
    },
    logo: {
        light: themeSettings.logo.light,
        dark: themeSettings.logo.dark
    },
    graphColors: {
        light: themeSettings.light.graphColors,
        dark: themeSettings.dark.graphColors
    }
}

const themeConfigs = [
    {
        name: THEMES.LIGHT,
        overrides: {
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: colors.blueGrey[600]
                    }
                }
            }
        },
        palette: {
            type: 'light',
            action: {
                active: colors.blueGrey[600]
            },
            background: {
                default: themeSettings.light.contentBackground,
                dark: themeSettings.light.background,
                paper: themeSettings.light.contentBackground
            },
            primary: {
                main: themeSettings.light.primary,
                contrastText: '#fff'
            },
            secondary: {
                main: themeSettings.light.secondary,
                contrastText: '#fff'
            },
            text: {
                primary: colors.blueGrey[900],
                pageTitlePrimary: colors.blueGrey[600],
                secondary: colors.blueGrey[700]
            },
            error: {
                main: '#dc004e'
            }
        },
        shadows: softShadows
    },
    {
        name: THEMES.DARK,
        palette: {
            type: 'dark',
            action: {
                active: 'rgba(255, 255, 255, 0.54)',
                hover: 'rgba(255, 255, 255, 0.04)',
                selected: 'rgba(255, 255, 255, 0.08)',
                disabled: 'rgba(255, 255, 255, 0.26)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                focus: 'rgba(255, 255, 255, 0.12)'
            },
            background: {
                default: themeSettings.dark.contentBackground,
                dark: themeSettings.dark.background,
                paper: themeSettings.dark.contentBackground
            },
            primary: {
                main: themeSettings.dark.primary
            },
            secondary: {
                main: themeSettings.dark.secondary
            },
            text: {
                primary: '#e6e5e8',
                secondary: '#adb0bb'
            },
            error: {
                main: '#dc004e'
            }
        },
        shadows: strongShadows
    }
]

export function createTheme(settings = {}) {
    let themeConfig = themeConfigs.find(theme => theme.name === settings.theme)

    if (!themeConfig) {
        console.warn(new Error(`The theme ${settings.theme} is not valid`))
        ;[themeConfig] = themeConfigs
    }

    let theme = createMuiTheme(_.merge({}, baseConfig, themeConfig, { direction: settings.direction }))

    if (settings.responsiveFontSizes) {
        theme = responsiveFontSizes(theme)
    }

    return theme
}
